import { render, staticRenderFns } from "./InformacoesBlocoComponent.vue?vue&type=template&id=602792aa"
import script from "./InformacoesBlocoComponent.vue?vue&type=script&lang=js"
export * from "./InformacoesBlocoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports